<template>
  <UModal
    :title="t('comps.consent_modal.preferencesTitle')"
    :description="t('comps.consent_modal.preferencesDescription')"
  >
    <template #body>
      <div
        class="flex flex-col gap-4 text-sm"
        v-html="t('comps.consent_modal.preferencesText')"
      />

      <UAccordion
        :items="items"
        :ui="{
          label: 'text-start break-words w-full flex flex-row gap-4 items-center',
        }"
      >
        <template #default="{ item }">
          <span class="font-semibold text-left grow">{{ item.label }}</span>
          <UBadge
            v-if="item.disabledSwitch"
            class="w-auto"
            :label="t('comps.consent_modal.alwaysEnabled')"
            color="neutral"
            variant="subtle"
          />
          <USwitch
            v-model="cookies.preferences[item.slot]"
            :disabled="item.disabledSwitch"
          />
        </template>
      </UAccordion>
    </template>
    <template #footer>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          color="neutral"
          variant="subtle"
          class="px-4 py-2 rounded"
          :label="t('comps.consent_modal.btnDeclineAll')"
          @click="cookies.disallow(true)"
        />
        <UButton
          color="neutral"
          variant="subtle"
          class="px-4 py-2 rounded"
          :label="t('comps.consent_modal.btnAcceptAll')"
          @click="cookies.allow(true)"
        />
      </div>
      <UButton
        class="px-4 py-2 rounded"
        :label="t('comps.consent_modal.btnAcceptChoosen')"
        @click="cookies.allow(false)"
      />
    </template>
  </UModal>
</template>

<script lang="ts" setup>
const cookies = useConsentStore()

defineEmits(['close'])

const items = [{
  label: t('comps.consent_modal.essential'),
  content: t('comps.consent_modal.essentialText'),
  slot: 'essential',
  disabledSwitch: true,
}, {
  label: t('comps.consent_modal.functionality'),
  content: t('comps.consent_modal.functionalityText'),
  slot: 'functionality',
}, {
  label: t('comps.consent_modal.analytics'),
  content: t('comps.consent_modal.analyticsText'),
  slot: 'analytics',
}, {
  label: t('comps.consent_modal.advertising'),
  content: t('comps.consent_modal.advertisingText'),
  slot: 'advertising',
}]
</script>
